import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { on } from '@ember/modifier';
import { fn, concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { and, eq, not, or } from 'ember-truth-helpers';
import set from 'ember-set-helper/helpers/set';
import { LinkTo } from '@ember/routing';
import perform from 'ember-concurrency/helpers/perform';
import scrollIntoView from 'ilios-common/modifiers/scroll-into-view';
import {
  faBan,
  faChartColumn,
  faCheck,
  faPenToSquare,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';

export default class SchoolSessionTypesListItemComponent extends Component {
  @tracked showRemoveConfirmation = false;

  scrollOpts = {
    behavior: 'smooth',
    block: 'nearest',
  };

  remove = task({ drop: true }, async () => {
    await this.args.sessionType.destroyRecord();
  });
  <template>
    <tr
      class="school-session-types-list-item{{if this.showRemoveConfirmation ' confirm-removal'}}"
      data-test-school-session-types-list-item
      ...attributes
    >
      <td colspan="3" data-test-title>
        <button
          class="link-button"
          type="button"
          {{on "click" (fn @manageSessionType @sessionType.id)}}
        >
          {{@sessionType.title}}
        </button>
        {{#unless @sessionType.active}}
          <em data-test-inactive>
            ({{t "general.inactive"}})
          </em>
        {{/unless}}
      </td>
      <td class="hide-from-small-screen" data-test-sessions-count>
        {{@sessionType.sessionCount}}
      </td>
      <td data-test-is-assessment>
        {{#if @sessionType.assessment}}
          <FaIcon @icon={{faCheck}} class="yes" />
        {{else}}
          <FaIcon @icon={{faBan}} class="no" />
        {{/if}}
      </td>
      <td class="hide-from-small-screen" colspan="2" data-test-assessment-option>
        {{@sessionType.assessmentOption.name}}
      </td>
      <td class="hide-from-small-screen" colspan="2" data-test-assessment-method-description>
        {{@sessionType.firstAamcMethod.description}}

        {{#if (and @sessionType.firstAamcMethod (not @sessionType.firstAamcMethod.active))}}
          <em>
            ({{t "general.inactive"}})
          </em>
        {{/if}}
      </td>
      <td class="calendar-color hide-from-small-screen">
        {{! template-lint-disable no-inline-styles style-concatenation no-triple-curlies}}
        <span
          class="box"
          data-test-colorbox
          style={{{concat "background-color: " @sessionType.safeCalendarColor}}}
        ></span>
      </td>
      <td>
        <button
          type="button"
          class="link-button"
          aria-label={{t "general.manage"}}
          data-test-manage
          {{on "click" (fn @manageSessionType @sessionType.id)}}
        >
          <FaIcon @icon={{faPenToSquare}} class="edit" />
        </button>
        {{#if (eq @sessionType.sessionCount 0)}}
          {{#if @canDelete}}
            <button
              type="button"
              class="link-button"
              aria-label={{t "general.remove"}}
              disabled={{or (this.showRemoveConfirmation this.deleteSessionType.isRunning)}}
              data-test-delete
              {{on "click" (set this "showRemoveConfirmation" true)}}
            >
              <FaIcon
                @icon={{faTrash}}
                class={{if
                  (or this.showRemoveConfirmation this.deleteSessionType.isRunning)
                  "inactive"
                  "remove"
                }}
              />
            </button>
          {{/if}}
        {{else}}
          <FaIcon
            @icon={{faTrash}}
            class="disabled"
            @title={{t "general.canNotDeleteSchoolSessionType"}}
          />
        {{/if}}
        <LinkTo
          @route="session-type-visualize-vocabularies"
          @model={{@sessionType}}
          title={{t "general.vocabularies"}}
        >
          <FaIcon @icon={{faChartColumn}} class="enabled" />
        </LinkTo>
      </td>
    </tr>
    {{#if this.showRemoveConfirmation}}
      <tr class="confirm-removal" {{scrollIntoView opts=this.scrollOpts}}>
        <td colspan="11" class="hide-from-small-screen">
          <div class="confirm-message" data-test-message>
            {{t "general.confirmRemoveSessionType"}}
            <br />
            <div class="confirm-buttons">
              <button
                type="button"
                class="remove text"
                {{on "click" (perform this.remove)}}
                data-test-confirm
              >
                {{t "general.yes"}}
              </button>
              <button
                type="button"
                class="done text"
                {{on "click" (set this "showRemoveConfirmation" false)}}
                data-test-cancel
              >
                {{t "general.cancel"}}
              </button>
            </div>
          </div>
        </td>
        <td colspan="5" class="hide-from-large-screen" data-test-confirm-removal>
          <div class="confirm-message" data-test-message>
            {{t "general.confirmRemoveSessionType"}}
            <br />
            <div class="confirm-buttons">
              <button
                type="button"
                class="remove text"
                {{on "click" (perform this.remove)}}
                data-test-confirm
              >
                {{t "general.yes"}}
              </button>
              <button
                type="button"
                class="done text"
                {{on "click" (set this "showRemoveConfirmation" false)}}
                data-test-cancel
              >
                {{t "general.cancel"}}
              </button>
            </div>
          </div>
        </td>
      </tr>
    {{/if}}
  </template>
}
